import { Button, Grid } from '@material-ui/core';
import { Hidden } from '@mui/material';
import { Dispatch, VFC } from 'react';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { SiteProcessSelectfield } from '../../input/ProcessSelectfield';
import { validationMessage } from '../../../../const/ProcessConst';
import { BaseModal } from '../../../molecules/BaseModal';
import { SiteProcessDatetimePicker } from '../../input/ProcessDatetimePicker';
import { QRCodeCanvas } from 'qrcode.react';
import { TDailyReportUrlModalForm } from '../../../../types/dailyReport';
import { formatDatetime } from '../../../../utils/common';
import { CustomTooltip } from '../../../tooltip/CustomTooltip';
import { tooltipContents } from '../../../tooltip/Const';
import HelpIcon from '@material-ui/icons/Help';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  constructId?: number;
};

export const DailyReportUrlModal: VFC<Props> = props => {
  const { isOpen, setIsOpen, constructId } = props;
  const classes = useStyles();

  const methods: UseFormReturn<TDailyReportUrlModalForm> = useForm();

  const {
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const {
    cancelSubmit,
    submit,
    constructList,
    publishedUrl,
    handleOnClickCopyLink,
    defaultExpirationDate
  } = useHooks({
    setIsOpen,
    reset,
    isOpen,
    constructIdDef: constructId
  });

  const theme = useTheme();
  const isXsDownScreen = useMediaQuery(theme.breakpoints.up('xs'));

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(submit, (erros: any) => {})}
      handleCancelSubmit={cancelSubmit}
      title={'日報URL'}
      buttonCaption={'発行する'}
      isCancelButton={false}
      isCloseIcon={true}
      extraFooter={
        publishedUrl &&
        publishedUrl !== '' && (
          <Grid container xs={10} alignItems='center' justify='center'>
            <Grid
              item
              xs={12}
              md={12}
              className={classes.publishedUrlContainer}
            >
              <div className={classes.publishedUrlTextContainer}>
                <div>共有リンク</div>
                <div>
                  <a href={publishedUrl} target='_blank' rel='noreferrer'>
                    {publishedUrl}
                  </a>
                </div>
                <div className={classes.copyLinkButtonWrap}>
                  <Button
                    className={classes.copyLinkButton}
                    onClick={handleOnClickCopyLink}
                  >
                    リンクをコピー
                  </Button>
                </div>
              </div>
              {isXsDownScreen && (
                <div className={classes.qrCodeWrapper}>
                  <QRCodeCanvas
                    value={publishedUrl}
                    className={classes.qrCode}
                  />
                </div>
              )}
            </Grid>
          </Grid>
        )
      }
    >
      <Grid container xs={10} alignItems='center' justify='center'>
        <FormProvider {...methods}>
          {/* 案件 */}
          <Grid container alignItems='center' justify='center'>
            <Grid item xs={10} md={3} className={classes.gridItem}>
              <label className={classes.label}>案件*</label>
            </Grid>
            <Grid item xs={10} md={9}>
              <SiteProcessSelectfield
                name='construct_id'
                listDatas={constructList}
                className={`${classes.input} ${classes.gridItem}`}
                required={true}
                error={'construct_id' in errors}
                errorMessage={
                  errors?.construct_id && validationMessage.required
                }
              />
            </Grid>
          </Grid>
          {/* /案件 */}
          {/* 有効期限 */}
          <Grid
            item
            xs={10}
            md={3}
            className={classes.gridItem}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <label className={classes.label}>有効期限*</label>
            <CustomTooltip title={tooltipContents.DailyReportExpirationDate}>
              <HelpIcon color='action' style={{ marginLeft: 8 }} />
            </CustomTooltip>
          </Grid>
          <Grid item xs={10} md={9}>
            <div className={classes.leftAlignContainer}>
              <Grid container>
                <Grid>
                  <div className={classes.itemMargin}>
                    <SiteProcessDatetimePicker
                      name='expiration_datetime'
                      defaultValue={defaultExpirationDate}
                      label='有効期限'
                      required={true}
                      fullWidth={true}
                      errorMessage={errors?.expiration_datetime?.message}
                      className={classes.gridItem}
                      fromDate={formatDatetime(new Date(), 'YYYY-MM-DD')}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* /有効期限 */}
        </FormProvider>
      </Grid>
    </BaseModal>
  );
};
